var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',[_c('video',{ref:"video",attrs:{"autoplay":""}})]),_vm._v(" "),_c('v-flex',[_c('canvas',{ref:"canvas"})])],1),_vm._v(" "),_c('v-layout',[_c('v-flex',[_c('p',[_vm._v(_vm._s(_vm.score))])])],1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dbce472","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/pcp/movimiento.vue
// module id = N9KT
// module chunks = 0